export const FETCH_BOOKINGS = 'FETCH_BOOKINGS'

export function fetchBookings(bookings) {
    return {type: FETCH_BOOKINGS, bookings}
}